import PropTypes from 'prop-types';
import { Stack, Chip, Link } from '@mui/material'

export const FilteredList = ({ filters, onChange }) => {

    const removeItem = (item) => {
        onChange(filters.filter((filter) => !(filter.field == item.field && filter.value == item.value)))
    }

    return (<Stack spacing={1} direction="row" justifyContent="center">
        {filters.map((item, i) => (
            <Chip key={i} label={item.text} onDelete={() => { removeItem(item) }} size="small" />
        ))}
        <Link component="button" variant="body2" size="small" onClick={() => { onChange([]) }}>Clear All</Link>
    </Stack>)
}

FilteredList.propTypes = {
    filters: PropTypes.object,
    onChange: PropTypes.func,
};